


























































import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { EVMBlockTransaction } from '@/store/modules/blocks'

@Component({
    components: {},
})
export default class EVMTxDataTable extends Vue {
    @Prop() transactions!: EVMBlockTransaction[]
    @Prop() title?: string

    get headers(): any[] {
        const headers = [
            { text: 'Type', value: 'type', width: 50 },
            { text: 'ID', value: 'hash', width: 50 },
            { text: 'From', value: 'v', width: 50 },
            { text: 'Value', value: 'value', width: 50 },
            { text: 'Input', value: 'input', width: 100 },
            { text: 'To', value: 'to' },
            { text: 'Gas Price', value: 'gasPrice', width: 100 },
            { text: 'Gas Used', value: 'gas', width: 100 },
        ]
        return headers
    }
}
